module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"meterValues":"Zählerstände","type":"Art","text":"Bezeichnung","meterNumber":"Zählernummer","value":"Wert","readingDate":"Ablesedatum","meter":"Zähler"},"en":{"meterValues":"Meter values","type":"Type","text":"Text","meterNumber":"Meter number","value":"Value","readingDate":"Reading date","meter":"Meter"}}')
  delete Component.options._Ctor
}
